export default [
    {
        path: '/login', 
        name: 'login',
        component: require('./components/auth/Login.vue').default 
    },
    {
        path: '/register', 
        name: 'register',
        component: require('./components/auth/Register.vue').default
    },
    {
        path: '/password/reset', 
        name: 'password_reset',
        component: require('./components/auth/PasswordReset.vue').default 
    },
    {
        path: '/password/reset/:token', 
        name: 'password_reset_token',
        component: require('./components/auth/PasswordReset.vue').default 
    },
    {
        path: '/email/verify', 
        name: 'email_verify',
        meta: { showVerify: true },
        component: require('./components/auth/Verify.vue').default 
    }
];
